module.exports = __webpack_public_path__ + "static/media/facebook.ff3fbd2c.svg";